"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_button_1 = require("@ryerson/frontend.button");

var FormWrapperClear = function FormWrapperClear(_a) {
  var label = _a.label,
      onClick = _a.onClick,
      rest = __rest(_a, ["label", "onClick"]);

  return (0, jsx_runtime_1.jsx)(frontend_button_1.Button, Object.assign({
    label: label,
    onClick: onClick
  }, rest));
};

FormWrapperClear.displayName = "FormWrapperClear";
exports.default = FormWrapperClear;